import { InboxOutlined } from '@ant-design/icons';
import { Upload as AntUpload } from 'antd';
import styled from 'styled-components';

import { ColorEnum } from '@enum/style/color.enum';

export const IconWrapper = styled.div`
  color: ${ColorEnum.Teal100};
`;

export const Icon = styled(InboxOutlined)`
  height: 48px;
  width: 48px;

  & svg {
    width: inherit;
    height: inherit;
  }
`;

export const DragUpload = styled(AntUpload.Dragger)`
  & .ant-upload.ant-upload-drag:hover {
    border-color: ${ColorEnum.Teal100};
  }
`;
